export default {"src":"/_next/static/image/src/images/about-house.369157daf958d2a1d107be2dc3806675.svg","height":40,"width":40};